<template>
  <div class="section-banner-container" >
    <slot name="content"/>
    <div v-if="showBanner" class="section-banner">
      <slot name="message">
        <p>
            To activate this feature please email
            <a href="mailto:clientvalue@vixio.com">clientvalue@vixio.com</a>
        </p>
      </slot>
      <div class="section-image-container">
        <slot name="icon" >
          <img src="@/assets/images/vixio.svg" alt="Vixio" />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showBanner: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isHovering: false
    };
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";

.section-banner {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
  z-index: 5;
  border-radius: 0.5rem;
  background-color: $midblue ;
  color: $light_blue;
  position: absolute;
  top: 60px;
  transform: translateX(-50%);
  left: 50%;
  padding: 1rem 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0; /* Hide the banner by default */
  transition: opacity 0.3s ease;
}

.section-banner-container:hover .section-banner {
  opacity: 1; /* Show the banner on hover */
}

.image-container {
  align-items: center;
}

a {
  color: $white;
}

img {
  width: 3.5rem;
  ;
}

</style>
